import { createFileRoute, Link, Navigate } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { useT } from "@/glossary";
import {
  EXERCISE_IDS,
  EXERCISES,
  useEverythingFinishedOnce,
  useExerciseStates,
} from "@/lib/exercises";
import { formatScore, getScoreFeedback } from "@/lib/score";

export const Route = createFileRoute("/summary")({
  component: SummaryPage,
});

function SummaryPage() {
  const t = useT();
  const everythingFinishedOnce = useEverythingFinishedOnce();
  const states = useExerciseStates();

  if (!everythingFinishedOnce) return <Navigate to="/" />;

  const rows = EXERCISE_IDS.map((id) => ({
    label: EXERCISES[id].summaryLabel(t),
    to: EXERCISES[id].path,
    score: states[id]?.bestScore ?? 0,
    max: (states[id]?.total ?? EXERCISES[id].total) * 100,
  }));
  const totalScore = rows.reduce((sum, r) => sum + r.score, 0);
  const totalMax = rows.reduce((sum, r) => sum + r.max, 0);

  return (
    <div className="flex flex-col items-center gap-6 p-8">
      <h1 className="font-bold text-2xl">{t.summary.title}</h1>
      <p className="whitespace-pre-line text-center">{t.summary.message}</p>
      <p>{getScoreFeedback(totalScore, totalMax, t)}</p>
      <div className="w-full space-y-3">
        {rows.map((row) => (
          <div
            key={row.to}
            className="flex items-center justify-between gap-4 border-foreground/20 border-b pb-2"
          >
            <Link to={row.to} className="underline-offset-4 hover:underline">
              {row.label}
            </Link>
            <span>
              {formatScore(row.score)}/{formatScore(row.max)}
            </span>
          </div>
        ))}
      </div>
      <Button as={Link} to="/" className="text-center">
        {t.common.home}
      </Button>
    </div>
  );
}
